export default __webpack_public_path__ + "static/media/KvOverviewSearchBg.14bdb7b2.jpg";